//dataFetch.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    homeImprovement: [],
    electronicCollection: [],
    topCollection: [],
    ourCollection: [],
}

export const collectionSlice = createSlice({
    name: 'homeImprovement',
    initialState,
    reducers: {
        homeImprovementRequest(state, action) {
            // debugger
            const {homeImprovement} = action.payload;
            state.homeImprovement = homeImprovement;
        },

        electronicCollectionRequest(state, action) {
            const {electronicCollection} = action.payload;
            state.electronicCollection = electronicCollection;
        },

        topCollectionRequest(state, action) {
            // debugger
            const {topCollection} = action.payload;
            state.topCollection = topCollection;
        },

        ourCollectionRequest(state, action) {
            const {ourCollection} = action.payload;
            state.ourCollection = ourCollection;
        },
}})

export const { homeImprovementRequest, electronicCollectionRequest, topCollectionRequest, ourCollectionRequest  } = collectionSlice.actions;


export default  collectionSlice.reducer;
